import { BaseService } from '@myhealth-raccoon/services';
import { authService } from '../auth';
import { CodeRequestType } from './types';

class VerificationCodeService extends BaseService {
    get Authorization() {
        return authService.Authorization;
    }

    constructor() {
        super('verificationcode', import.meta.env.VITE_AUTH_API_URL);
    }

    public async GenerateCode(type: CodeRequestType) {
        return await this.post('generateandsend/contactType', type);
    }
}

export const verificationCodeService = new VerificationCodeService();
export * from './types';
